import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledStatusHeader = styled.div`
  display: flex;
  flex-direction: row;
  padding: 20px;
  align-items: center;
  gap: 32px;
  border-bottom: 1px solid ${theme.colors.purple_2};

  & > button {
    width: 165px;
  }

  & > div > div > div {
    margin: 2px 0;
  }
`;

export const StyledStatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  & div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  & .step-divider {
    width: 20px;
    border-bottom: 1px solid ${theme.colors.grey_4};
    display: block;
  }

  & .steps-container div:last-child .step-divider {
    display: none;
  }

  & div > span:first-child {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100px;
    width: 20px;
    height: 20px;
    border: 1px solid ${theme.colors.grey_4};
  }

  & div > span:first-child.active {
    border: 1px solid ${theme.colors.purple};
  }

  & div > span:first-child.complete {
    background: ${theme.colors.purple};
    border: 1px solid ${theme.colors.purple};
  }

  & .steps-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    & > div {
      gap: 8px;
    }
  }
`;
